var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "composition-product",
      class: { "has-link": _vm.detailLink },
      on: { click: _vm.goProductDetail },
    },
    [
      _c("div", { staticClass: "product-thumbnail" }, [
        _c("img", {
          attrs: {
            src: _vm.product.course
              ? _vm.product.course.desktopCardAssetUrl
              : _vm.productThumbImgUrl,
            alt: "",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "product-desc" }, [
        _c("span", { staticClass: "product-desc__title" }, [
          _vm._v(_vm._s(_vm.product.title)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "product-desc__price" }, [
          _vm._v(
            "현재 판매가 " +
              _vm._s(_vm._f("numeric")(_vm.product.listPrice)) +
              "원"
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }